<template>
    <div class="position-relative task-kanban-wrapper"
         ref="kanbans">
        <div class="task-kanban d-flex flex-row flex-nowrap align-items-start px-3 py-2 h-100">
            <template v-if="isLoading">
                <kanban-column-loading></kanban-column-loading>
                <kanban-column-loading></kanban-column-loading>
                <kanban-column-loading></kanban-column-loading>
                <kanban-column-loading></kanban-column-loading>
                <kanban-column-loading></kanban-column-loading>
                <kanban-column-loading></kanban-column-loading>
                <kanban-column-loading></kanban-column-loading>
                <kanban-column-loading></kanban-column-loading>
            </template>
            <template v-else>
                <kanban-column v-for="stage in taskStages"
                               v-bind:key="stage._id"
                               v-bind:title="stage.name"
                               v-bind:stage="stage">
                </kanban-column>
            </template>
        </div>

        <task-details></task-details>
    </div>
</template>

<script>
import KanbanColumn from "./Kanban/KanbanColumn";
import TaskDetails from "./TaskDetails";
import KanbanColumnLoading from "./Kanban/KanbanColumnLoading";

export default {
    name: "TaskKanban",
    components: {
        KanbanColumnLoading,
        KanbanColumn,
        TaskDetails,
    },
    data() {
        return {};
    },
    computed: {
        isLoading() {
            return this.$store.state.tasks.isStagesLoading;
        },
        taskStages() {
            return this.$store.state.tasks.stages;
        },
    },
    methods: {},
}
</script>

<style lang="scss" scoped>
.task-kanban-wrapper {
    height: calc(100% - 49.5px);
    overflow: visible;

    .task-kanban {
        overflow-x: scroll;
        -webkit-overflow-scrolling: touch;
    }
}

</style>
